import { Marked } from 'marked';

/**
 * Renders help-article markdown to HTML. Links written relative to the site (`/help/<slug>`) point
 * at the public help centre on `frontOrigin`, and every link opens in a new tab, so a merchant or
 * admin reading inside the dashboard never navigates away from it.
 *
 * The output is not sanitised here: bind it with `[innerHTML]`, where Angular strips scripts and
 * event handlers.
 */
export function renderMarkdown(markdown: string | null | undefined, frontOrigin: string): string {
  const marked = new Marked({
    gfm: true,
    walkTokens: (token) => {
      if (token.type === 'link' && token.href.startsWith('/')) token.href = frontOrigin + token.href;
    },
  });

  const html = marked.parse(markdown ?? '', { async: false });

  return html.replaceAll('<a href=', '<a target="_blank" rel="noopener noreferrer" href=');
}
